import { forwardRef, type HTMLAttributes, type ReactNode } from 'react';
import { cn } from '@/shared/lib/cn';
import './Avatar.css';

export type AvatarSize = 'sm' | 'md' | 'lg';
export type AvatarVariant = 1 | 2 | 3 | 4 | 5 | 6;
export type AvatarStatus = 'online' | 'away' | 'offline';

export interface AvatarProps extends HTMLAttributes<HTMLDivElement> {
  initials: string;
  size?: AvatarSize;
  variant?: AvatarVariant;
  status?: AvatarStatus;
}

export const Avatar = forwardRef<HTMLDivElement, AvatarProps>(function Avatar(
  { initials, size = 'md', variant = 1, status, className, ...rest },
  ref,
) {
  return (
    <div
      ref={ref}
      className={cn(
        'itb-avatar',
        `itb-avatar--${size}`,
        `itb-avatar--v${variant}`,
        className,
      )}
      {...rest}
    >
      {initials}
      {status && (
        <span
          className={cn('itb-avatar__status', `itb-avatar__status--${status}`)}
          aria-hidden
        />
      )}
    </div>
  );
});

export interface AvatarStackProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

export function AvatarStack({ children, className, ...rest }: AvatarStackProps) {
  return (
    <div className={cn('itb-avatar-stack', className)} {...rest}>
      {children}
    </div>
  );
}
